module.exports = __webpack_public_path__ + "img/roast_ig.e13d3e11.png";